import { Component,  Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatSidenav } from 'src/app/core/core';
import { OktaAuthStateService } from '@okta/okta-angular';
import { ICtaNavigationItem } from 'src/app/model/sitefinity/ICtaNavigationItem';
import { PGHOktaService } from 'src/app/core/core';

import { LoggedInNavlistComponent } from './logged-in-navlist/logged-in-navlist.component';
import { LoggedOutNavlistComponent } from './logged-out-navlist/logged-out-navlist.component';

export enum NavLists {
  none,
  root,
  profile,
  claims,
  coverage
}

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    imports: [LoggedInNavlistComponent, LoggedOutNavlistComponent]
})
export class SidenavComponent implements OnInit, OnChanges {
  @Input() isShowing: boolean;
  @Input() sidenavRef: MatSidenav;

  NavLists = NavLists;
  isAuthenticated: boolean = false;
  currentNavList: number = NavLists.root;
  userGivenName: string = '';
  headerChildItems: { [id: string]: ICtaNavigationItem };

  constructor(
    private oktaAuth: OktaAuthStateService,
    private pghOktaService: PGHOktaService
  ) { }

  async ngOnInit(): Promise<void> {
    this.isAuthenticated = this.pghOktaService.isTokenValid();
    if (this.isAuthenticated) {
      this.pghOktaService.getUser().then(user => this.userGivenName = user.given_name);
    }
   this.oktaAuth.authState$.subscribe(authState => this.isAuthenticated = authState.isAuthenticated);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isShowing && changes.isShowing.currentValue === false) {
      this.currentNavList = NavLists.root;
    }
  }
}
